/* Catalogo: filtros por servidor sin recarga (Section Rendering API), URL
   compartible (pushState), scroll infinito, paneles, orden y vista.
   - Precio: se escribe libre; se aplica al salir del campo, con Enter o tras
     600ms de pausa. Asi el catalogo no se vacia entre digito y digito.
   - Los paneles se cierran por click afuera (listener en captura + zona
     marcada) y con Escape devolviendo el foco.
   - Al reemplazar la grilla: NO scrollIntoView; el revelado se re-crea con un
     WeakSet nuevo y rescate por medicion (grilla en blanco = bug conocido). */
const { mount, reveal, desregistro, reduced, fetchSection } = window.EQ;

/* Texto "buscable" para los paneles (Artista, Genero): sin tildes ni signos, y
   los numeros-letra leidos como letra, porque la gente escribe como lo dice:
   "catriel" encuentra CA7RIEL, "garcia" encuentra García, "y" = "&". Se aplica
   igual al texto buscado y a la opcion, asi que tambien "ca7riel" encuentra. */
const buscable = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/&/g, ' y ').replace(/[4@]/g, 'a').replace(/3/g, 'e').replace(/[1!]/g, 'i').replace(/0/g, 'o')
  .replace(/[5$]/g, 's').replace(/7/g, 't').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();

mount('[data-eq-catalogo]', (root) => {
  const sid = root.dataset.sectionId;
  let rev = reveal(root);
  let tPrecio = 0, cargando = false, panelAbierto = null, io = null;
  const vistaKey = 'eq:vista';

  // ---- entrada: desregistro del titulo, una sola vez ---------------------
  const des = root.querySelector('[data-eq-desreg]');
  const bajada = root.querySelector('[data-eq-bajada]');
  desregistro(des, des && des.dataset.on !== 'false');
  if (bajada) {
    if (reduced()) bajada.classList.add('is-still');
    else window.EQ.fontsReady().then(window.EQ.raf2).then(() => bajada.classList.add('is-in'));
  }

  // ---- paneles ------------------------------------------------------------
  const cerrarPaneles = () => {
    root.querySelectorAll('[data-eq-panel]').forEach((p) => { p.hidden = true; });
    root.querySelectorAll('[data-eq-panel-btn]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    panelAbierto = null;
  };
  const abrirZona = (zona) => {
    const panel = zona && zona.querySelector('[data-eq-panel]');
    if (!panel) return;
    const btn = zona.querySelector('[data-eq-panel-btn]');
    panel.hidden = false;
    if (btn) btn.setAttribute('aria-expanded', 'true');
    panelAbierto = zona;
    const q = panel.querySelector('[data-eq-panel-q]');
    if (q) q.focus();
  };

  // ---- chip activo: el rotulo EDITA (abre el panel de su filtro) ----------
  // El mousedown de "click afuera" corre antes que el click y ya cerro el
  // panel; por eso se anota que panel estaba abierto y cuando. Sin mousedown
  // reciente (teclado) vale el estado actual.
  let ultimoDown = null;
  const tope = () => {
    const h = document.querySelector('.eq-sec-header');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  };
  // si la fila de filtros quedo arriba del header fijo, bajarla a 24px de el
  const traerFiltros = () => new Promise((r) => {
    const fila = root.querySelector('[data-eq-filtros]');
    if (!fila || fila.getBoundingClientRect().top >= tope()) { r(); return; }
    const destino = () => window.scrollY + fila.getBoundingClientRect().top - (tope() + 24);
    if (reduced()) { window.scrollTo({ top: destino(), behavior: 'auto' }); r(); return; }
    window.scrollTo({ top: destino(), behavior: 'smooth' });
    let hecho = false, t = 0;
    const fin = () => {
      if (hecho) return;
      hecho = true; clearTimeout(t); window.removeEventListener('scrollend', fin);
      // el header puede cambiar de alto al subir: un ajuste final, sin animar
      if (fila.getBoundingClientRect().top < tope() + 23) window.scrollTo({ top: destino(), behavior: 'auto' });
      r();
    };
    window.addEventListener('scrollend', fin);
    t = setTimeout(fin, 1000);
  });
  const editar = async (k) => {
    const zona = Array.from(root.querySelectorAll('[data-eq-panel-zone][data-eq-fkey]')).find((z) => z.dataset.eqFkey === k) || null;
    const reciente = ultimoDown && performance.now() - ultimoDown.t < 600;
    const estaba = reciente ? ultimoDown.panel : panelAbierto;
    ultimoDown = null;
    // segundo click en el mismo rotulo = cerrar su panel
    if (zona && estaba === zona) { cerrarPaneles(); return; }
    cerrarPaneles();
    await traerFiltros();
    // sin panel (Nacional/Importado): solo se trae la fila a la vista
    if (zona) abrirZona(zona);
  };

  const onClick = (e) => {
    const ed = e.target.closest('[data-eq-editar]');
    if (ed && root.contains(ed)) { e.preventDefault(); editar(ed.dataset.eqEditar); return; }
    const btn = e.target.closest('[data-eq-panel-btn]');
    if (btn && root.contains(btn)) {
      const zona = btn.closest('[data-eq-panel-zone]');
      const panel = zona && zona.querySelector('[data-eq-panel]');
      const abrir = panel && panel.hidden;
      cerrarPaneles();
      if (abrir) abrirZona(zona);
      return;
    }
    const orden = e.target.closest('[data-eq-orden]');
    if (orden) { const s = root.querySelector('[data-eq-sort]'); if (s) s.value = orden.dataset.eqOrden; cerrarPaneles(); aplicar(); return; }
    const seg = e.target.closest('[data-eq-seg], [data-eq-seg-todos]');
    if (seg) {
      const form = root.querySelector('[data-eq-filtros]');
      const param = seg.dataset.eqSeg || seg.dataset.eqSegTodos;
      form.querySelectorAll('[data-eq-seg-hidden="' + param + '"]').forEach((h) => h.remove());
      if (seg.dataset.eqSeg) {
        const h = document.createElement('input');
        h.type = 'hidden'; h.name = param; h.value = seg.dataset.eqVal; h.dataset.eqSegHidden = param;
        form.appendChild(h);
      }
      aplicar();
      return;
    }
    const vista = e.target.closest('[data-eq-vista]');
    if (vista) { setVista(vista.dataset.eqVista); return; }
    const chip = e.target.closest('[data-eq-chip], [data-eq-limpiar]');
    if (chip && chip.getAttribute('href')) { e.preventDefault(); cerrarPaneles(); irA(chip.getAttribute('href')); }
  };
  const onDown = (e) => {
    ultimoDown = { panel: panelAbierto, t: performance.now() };
    if (!panelAbierto) return;
    if (e.target.closest && e.target.closest('[data-eq-panel-zone]') === panelAbierto) return;
    cerrarPaneles();
  };
  const onKey = (e) => {
    if (e.key !== 'Escape' || !panelAbierto) return;
    const b = panelAbierto.querySelector('[data-eq-panel-btn]');
    cerrarPaneles();
    if (b) b.focus();
  };
  const onChange = (e) => {
    if (e.target.matches('input[type="checkbox"]')) aplicar();
  };
  const onInput = (e) => {
    if (e.target.matches('[data-eq-precio]')) { clearTimeout(tPrecio); tPrecio = setTimeout(aplicarPrecio, 600); }
    if (e.target.matches('[data-eq-panel-q]')) {
      // se oculta por style: `hidden` no alcanzaba (el display:flex de
      // .eq-check le gana y la busqueda "no hacia nada")
      const q = buscable(e.target.value);
      const panel = e.target.closest('[data-eq-panel]');
      let visibles = 0;
      panel.querySelectorAll('[data-eq-opt-label]').forEach((l) => {
        const t = buscable(l.dataset.eqOptLabel);
        const ok = !q || t.includes(q) || t.replace(/ /g, '').includes(q.replace(/ /g, ''));
        l.style.display = ok ? '' : 'none';
        if (ok) visibles++;
      });
      const vacio = panel.querySelector('[data-eq-panel-vacio]');
      if (vacio) vacio.style.display = visibles ? 'none' : '';
    }
  };
  const onBlurCap = (e) => { if (e.target.matches && e.target.matches('[data-eq-precio]')) aplicarPrecio(); };
  const onKeyPrecio = (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-eq-precio]')) { e.preventDefault(); aplicarPrecio(); }
    // Enter en el buscador de un panel no envia el formulario
    if (e.key === 'Enter' && e.target.matches('[data-eq-panel-q]')) e.preventDefault();
  };
  let precioAplicado = '';
  const aplicarPrecio = () => {
    clearTimeout(tPrecio);
    const v = Array.from(root.querySelectorAll('[data-eq-precio]')).map((i) => i.value).join('|');
    if (v === precioAplicado) return;
    precioAplicado = v;
    aplicar();
  };

  // ---- aplicar filtros -----------------------------------------------------
  const urlActual = () => {
    const form = root.querySelector('[data-eq-filtros]');
    const u = new URL(form.getAttribute('action') || location.pathname, location.origin);
    const fd = new FormData(form);
    for (const [k, v] of fd.entries()) { if (String(v).trim() !== '') u.searchParams.append(k, v); }
    return u.toString();
  };
  const aplicar = () => irA(urlActual());
  const irA = async (url) => {
    const res = root.querySelector('[data-eq-resultados]');
    res.classList.add('is-loading');
    try {
      const doc = await fetchSection(url, sid);
      const nuevo = doc.querySelector('[data-eq-catalogo]');
      if (!nuevo) throw new Error('sin seccion');
      ['[data-eq-filtros]', '[data-eq-bar]', '[data-eq-resultados]'].forEach((sel) => {
        const a = root.querySelector(sel), b = nuevo.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      });
      precioAplicado = Array.from(root.querySelectorAll('[data-eq-precio]')).map((i) => i.value).join('|');
      const limpia = new URL(url, location.origin);
      limpia.searchParams.delete('section_id');
      history.pushState({ eq: 1 }, '', limpia.toString());
      panelAbierto = null;
      rev.destroy(); rev = reveal(root);
      setVista(localStorage.getItem(vistaKey) || 'grilla', true);
      observarFondo();
    } catch (err) {
      window.location.href = url; // sin JS o con error: navegacion normal
    } finally {
      res.classList.remove('is-loading');
    }
  };
  const onPop = () => { irA(location.href); };

  // ---- vista grilla / lista (conveniencia por visitante) --------------------
  const setVista = (v, silencio) => {
    const g = root.querySelector('[data-eq-grilla]'), l = root.querySelector('[data-eq-lista]');
    if (g) g.hidden = v === 'lista';
    if (l) l.hidden = v !== 'lista';
    root.querySelectorAll('[data-eq-vista]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.eqVista === v ? 'true' : 'false'));
    try { localStorage.setItem(vistaKey, v); } catch (e) {}
    if (!silencio) rev.scan();
  };
  try { setVista(localStorage.getItem(vistaKey) || 'grilla', true); } catch (e) {}

  // ---- scroll infinito -----------------------------------------------------
  const cargarMas = async () => {
    const fondo = root.querySelector('[data-eq-fondo]');
    const next = fondo && fondo.dataset.next;
    if (!next || cargando) return;
    cargando = true;
    try {
      const doc = await fetchSection(next, sid);
      const nuevo = doc.querySelector('[data-eq-catalogo]');
      const g = root.querySelector('[data-eq-grilla]'), l = root.querySelector('[data-eq-lista]');
      const ng = nuevo.querySelector('[data-eq-grilla]'), nl = nuevo.querySelector('[data-eq-lista]');
      if (g && ng) Array.from(ng.children).forEach((c) => g.appendChild(c));
      if (l && nl) Array.from(nl.children).forEach((c) => l.appendChild(c));
      const nf = nuevo.querySelector('[data-eq-fondo]');
      if (nf && nf.dataset.next) fondo.dataset.next = nf.dataset.next; else delete fondo.dataset.next;
      const mas = root.querySelector('[data-eq-mas]'), nmas = nuevo.querySelector('[data-eq-mas]');
      const fin = nuevo.querySelector('.eq-res__fin');
      if (mas) { if (nmas) mas.innerHTML = nmas.innerHTML; else if (fin) mas.replaceWith(fin); else mas.remove(); }
      rev.scan();
    } catch (err) {
      console.error('[EQ] catalogo: mas', err);
    } finally {
      cargando = false;
      observarFondo();
    }
  };
  const observarFondo = () => {
    if (io) io.disconnect();
    const fondo = root.querySelector('[data-eq-fondo]');
    if (!fondo || !fondo.dataset.next) return;
    io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) cargarMas(); }, { rootMargin: '700px 0px' });
    io.observe(fondo);
  };
  observarFondo();

  root.addEventListener('click', onClick);
  root.addEventListener('change', onChange);
  root.addEventListener('input', onInput);
  root.addEventListener('blur', onBlurCap, true);
  root.addEventListener('keydown', onKeyPrecio);
  document.addEventListener('mousedown', onDown, true);
  document.addEventListener('keydown', onKey);
  window.addEventListener('popstate', onPop);
  precioAplicado = Array.from(root.querySelectorAll('[data-eq-precio]')).map((i) => i.value).join('|');

  return () => {
    rev.destroy();
    if (io) io.disconnect();
    clearTimeout(tPrecio);
    root.removeEventListener('click', onClick);
    root.removeEventListener('change', onChange);
    root.removeEventListener('input', onInput);
    root.removeEventListener('blur', onBlurCap, true);
    root.removeEventListener('keydown', onKeyPrecio);
    document.removeEventListener('mousedown', onDown, true);
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('popstate', onPop);
  };
});
